import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import ClientesPage from "@/pages/ClientesPage";
import PresupuestosPage from "@/pages/PresupuestosPage";
import FacturasPage from "@/pages/FacturasPage";
import CobrosPage from "@/pages/CobrosPage";
import BancoPage from "@/pages/BancoPage";
import GastosPage from "@/pages/GastosPage";
import CalendarioPage from "@/pages/CalendarioPage";
import ConfiguracionPage from "@/pages/ConfiguracionPage";
import MensajesPage from "@/pages/MensajesPage";
import DocumentForm from "@/components/DocumentForm";
import { PagoExitoPage, PagoCanceladoPage } from "@/pages/PagoPages";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/pago/exito" element={<PagoExitoPage />} />
          <Route path="/pago/cancelado" element={<PagoCanceladoPage />} />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="clientes" element={<ClientesPage />} />
            <Route path="presupuestos" element={<PresupuestosPage />} />
            <Route path="presupuestos/nuevo" element={<DocumentForm mode="quote" />} />
            <Route path="facturas" element={<FacturasPage />} />
            <Route path="facturas/nueva" element={<DocumentForm mode="invoice" />} />
            <Route path="cobros" element={<CobrosPage />} />
            <Route path="banco" element={<BancoPage />} />
            <Route path="gastos" element={<GastosPage />} />
            <Route path="calendario" element={<CalendarioPage />} />
            <Route path="mensajes" element={<MensajesPage />} />
            <Route path="configuracion" element={<ConfiguracionPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
